import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTextarea,_vm._b({attrs:{"outlined":"","color":"input","value":_vm.value},on:{"input":_vm.updateValue}},'v-textarea',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }